import IGlobalState from '@/interfaces/IGlobalState';
import {
  Marker, Map, LayerGroup, LatLng,
} from 'leaflet';

const GlobalState: IGlobalState = {
  currentRoute: {
    path: '',
    hash: '',
    query: {},
    params: {},
    fullPath: '',
    matched: [],
  },
  drawerActive: false,
  infoDrawerActive: false,
  position: {
    lat: 50.01254821277426,
    lng: 20.987751781940464,
  },
  zoomFactor: 13,
  mapSettings: {
    settings: {
      trafficUpToDateTime: '',
      cctvUpToDateTime: '',
      vmsUpToDateTime: '',
      parkingStatusUpToDateTime: '',
      radarUpToDateTime: '',
      weatherForecastUpToDateTime: '',
      fixedCamerasPreview: false,
      ptzCamerasPreview: false,
      vmsPreview: false,
      visibilityOfModules: {
        traffic: false,
        trafficAccidents: false,
        accident: false,
        constructions: false,
        hazard: false,
        roadClosed: false,
        parkingZone: false,
        parkingMeters: true,
        parkings: true,
        parkingGroups: true,
        parkingSpots: true,
        cctvFixedCameras: false,
        cctvPtzCameras: false,
        vms: false,
        radars: false,
        poiPoint: false,
        weatherStations: false,
        events: true,
      },
    },
    mapConfiguration: {
      traffic: false,
      trafficAccidents: false,
      accident: true,
      constructions: false,
      hazard: false,
      roadClosed: false,
      parkingZone: true,
      parkingMeters: true,
      parkings: true,
      parkingGroups: true,
      parkingSpots: true,
      cctvFixedCameras: false,
      cctvPtzCameras: false,
      vms: false,
      radars: false,
      poiPoint: {},
      weatherStations: false,
      // dodany mój własny klucz do obsługi grupowego wyświetlania (lub nie) zdarzeń
      events: true,
    },
    segmentsConfig: {
      parametr: '',
      noDataColor: '',
      defaultColor: '',
      values: {},
    },
  },
  parkings: {
    type: '',
    features: [],
  },
  parkingZones: {
    type: '',
    features: [],
  },
  parkingMeters: {
    type: '',
    features: [],
  },
  parkingSpots: {
    type: '',
    features: [],
  },
  parkingGroups: {
    type: '',
    features: [],
  },
  events: {
    type: '',
    features: [],
  },
  weatherStations: {
    type: '',
    features: [],
  },
  posts: {
    posts: [],
  },
  currentWeather: {
    tempAir: 0,
    tempSurf: 0,
    dewPoint: 0,
    heatIndex: 0,
    humidex: 0,
    humidity: 0,
    pressure: 0,
    freezingPoint: 0,
    iceThickness: 0,
    visibility: 0,
    airCO: 0,
    airCO2: 0,
    airNO: 0,
    airNO2: 0,
    airSO2: 0,
    'airPM2.5': 0,
    airPM10: 0,
    airHC: 0,
    noise: 0,
    windSpeed: 0,
    windDeg: 0,
    windGust: 0,
    surfState: '',
    surfMoisture: '',
    salt: 0,
    precipitationOnMinute: 0,
  },
  userPositionMarker: Marker.prototype,
  modes: {
    selectLocation: true,
    showOverlay: false,
  },
  leafletMapInstance: Map.prototype,
  leafletLayers: {
    parkingLayer: LayerGroup.prototype,
    parkingZones: LayerGroup.prototype,
    parkingZonesMarkers: LayerGroup.prototype,
    parkingMeters: LayerGroup.prototype,
    parkingSpots: LayerGroup.prototype,
    parkingGroups: LayerGroup.prototype,
    eventsAccidents: LayerGroup.prototype,
    eventsBuilding: LayerGroup.prototype,
    eventsBlocks: LayerGroup.prototype,
    eventsHazard: LayerGroup.prototype,
    weatherStations: LayerGroup.prototype,
  },
  modal: {
    data: {
      title: '',
      content: '',
      navigationPoint: undefined,
      icon: '',
      lastUpdate: (new Date()).toJSON(),
    },
    display: false,
  },
  contrast: false,
  fontSize: 2,
};

export default GlobalState;
